'use client';

import { TooltipProviderProps } from '@radix-ui/react-tooltip';
import Link from 'next/link';
import { usePathname, useRouter } from 'next/navigation';

import { TooltipProvider } from '../molecules/tooltip/tooltip';
import { RouterContextProps, RouterProvider } from './router';
import { TranslationsProvider } from './translations';

/**
 * Ark Provider!
 */
export type ArkProviderProps = React.PropsWithChildren & {
  /**
   * Options to override default functionality for tooltips.
   */
  tooltips?: TooltipProviderProps;
  /**
   * Theoretical prop in case we need a router other than Next's.
   */
  routerData?: RouterContextProps;
  locale?: string;
};

export const ArkProvider: React.FC<ArkProviderProps> = ({
  children,
  routerData,
  tooltips,
  locale,
}) => {
  // This is assuming we're always within NextJS.
  // In reality we doubt we'll ever be using this outside of NextJS apps,
  // but we do then we should come up with a slicker way to lazy load the NextJS functionality.
  const nextRouter = useRouter();
  const routerProps = {
    routerData: {
      router: nextRouter,
      RouterComponent: Link,
      usePathname,
      ...routerData,
    },
  };

  return (
    <TranslationsProvider locale={locale || 'en'}>
      <RouterProvider {...routerProps}>
        <TooltipProvider {...tooltips}>{children}</TooltipProvider>
      </RouterProvider>
    </TranslationsProvider>
  );
};
